import { type SecondaryNavGroup } from '.'
import {
  USER_LINKS,
  SITE_LINKS,
  TEAM_LINKS,
  ORGANISATION_LINKS,
  CUSTOMER_SINGLE_PAGE_TEST_LINKS,
  NON_CUSTOMER_SINGLE_PAGE_TEST_LINKS
} from './secondary-nav-config'

interface getLinksProps {
  siteId?: string
  teamId?: string
  orgId?: string
  uuid?: string
  shareToken?: string
  matchUser: boolean
  singlePageTest: boolean
  userIsCustomer?: boolean
}

export const getLinks = ({
  siteId,
  teamId,
  orgId,
  matchUser,
  singlePageTest,
  userIsCustomer
}: getLinksProps): SecondaryNavGroup[] => {
  if (matchUser) return USER_LINKS
  if (singlePageTest && userIsCustomer) return CUSTOMER_SINGLE_PAGE_TEST_LINKS
  if (singlePageTest && !userIsCustomer) return NON_CUSTOMER_SINGLE_PAGE_TEST_LINKS
  if (siteId) return SITE_LINKS
  if (teamId) return TEAM_LINKS
  if (orgId) return ORGANISATION_LINKS
  return []
}
